module.exports = __webpack_public_path__ + "static/media/PCA_m_white_long_new_mattia.b7d6cafc.svg";